import React from "react";
import SideMenu from "../../sharedScreens/menuItems/SideMenu";
import Header from "../../sharedScreens/Header";
import MuiButton from "../../components/basicComponent/MuiButton";
import { MuiInput } from "../../components/basicComponent/MuiInput";
import MuiDatePicker from "../../components/basicComponent/MuiDatePicker";
import dayjs from "dayjs";
import { MuiDropDown } from "../../components/basicComponent/MuiDropDown";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Tabs } from "@mui/material";
import MuiSearchSelect from "./../../components/basicComponent/MuiSearchSelect";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const PGCharges = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header mb-1 ">
              <h3 className="card-title titlecolorr">PG Charges</h3>
            </div>
            <div className="card">
              <div className="row">
                <div className="col-md-12">
                  <Box sx={{ width: "100%" }}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                      >
                        <Tab label="Category" {...a11yProps(0)} />
                        <Tab label="Assign" {...a11yProps(1)} />
                        <Tab label="View" {...a11yProps(2)} />
                      </Tabs>
                    </Box>
                    <CustomTabPanel value={value} index={0}>
                      <div className="row mt-4">
                        <div className="col-md-4">
                          <MuiDropDown
                            label="Assigned Category"
                            placeholder="Assigned Category"
                            isRequired
                            options={[]}
                            onChange={function (
                              value: string,
                              id: string
                            ): void {
                              throw new Error("Function not implemented.");
                            }}
                            value={""}
                          />
                        </div>
                        <div className="col-md-4">
                          <MuiInput
                            label="Category Name"
                            placeholder="Category Name"
                          />
                        </div>
                        <div className="col-md-4">
                          <MuiInput label="Type" placeholder="Enter Type" />
                        </div>
                        <div className="col-md-4 mt-3">
                          <MuiInput
                            label="Transaction Charge"
                            placeholder="Transaction Charge"
                          />
                        </div>

                        <div className="user-button w-full mt-4">
                          <MuiButton
                            className="main-btn get-btn"
                            variant="contained"
                            size="large"
                            type="submit"
                            label={"Submit"}
                          />
                        </div>
                      </div>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                      <div className="row">
                        <div className="col-md-4 mt-3">
                          <MuiInput
                            label="Category"
                            placeholder="Enter Category"
                          />
                        </div>
                        <div className="col-md-4 mt-3">
                          <MuiInput
                            label="Business Type"
                            placeholder="Business Type"
                          />
                        </div>
                        <div className="col-md-4 mt-3">
                          <MuiInput
                            label="Customer Name"
                            placeholder="Customer Name"
                          />
                        </div>

                        <div className="user-button w-full mt-5">
                          <MuiButton
                            className="main-btn get-btn"
                            variant="contained"
                            size="large"
                            type="submit"
                            label={"Submit"}
                          />
                        </div>
                      </div>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={2}>
                      <div className="row">
                        <div className="col-md-4 mt-3">
                          <MuiSearchSelect
                            label="Business Type"
                            placeholder="Business Type"
                            options={[]}
                            onChange={function (
                              value: string,
                              id: string,
                              data: any
                            ): void {
                              throw new Error("Function not implemented.");
                            }}
                            value={""}
                          />
                        </div>
                        <div className="col-md-4 mt-3">
                          <MuiInput
                            label="Customer Name"
                            placeholder="Customer Name"
                          />
                        </div>
                        <div className="col-md-4 mt-3">
                          <MuiInput
                            label="Supplier Name"
                            placeholder="Supplier Name"
                          />
                        </div>
                        
                        <div className="col-md-4 mt-3">
                        <MuiSearchSelect
                          placeholder={"Status"}
                          label="Status"
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                        </div>

                        <div className="user-button w-full mt-5">
                          <MuiButton
                            className="clear-btn"
                            label="Clear"
                            type="submit"
                          />
                          <MuiButton
                            className="main-btn get-btn"
                            variant="contained"
                            size="large"
                            type="submit"
                            label={"Submit"}
                          />
                        </div>
                      </div>
                    </CustomTabPanel>
                  </Box>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default PGCharges;
